import { Injectable } from '@angular/core';
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../../environments/environment";
import * as HSET from "../settings";
import { GenericHttpService } from "../../../../services/generic-http.service";
import { ApiUrlConstant } from "./../../../../constants/api-url.constant";
import { Observable } from "rxjs";
import { GenericUtils } from './../../../../utilities/generic-utils';

const month = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
@Injectable()
export class WidgetStatusRigionwiseStatusService {
  baseUrl = environment.gateWayHost;
  editItem: any;

  constructor(
    public generic: GenericHttpService,
    private apiUrl: ApiUrlConstant,
    private utils:  GenericUtils
  ) { }

  getData(options): Observable<any> {
    const option = {
      method: "GET",
      url: `${this.baseUrl}${options.url}`,
      //url: './assets/data/status-regionwise.json',
      query: options.params
    };
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(this.processRegionWiseStatus)
    );
  }
  processRegionWiseStatus(data: any) {
    const delivered = [];
    const in_transit = [];
    const invoiced = [];
    const to_be_invoiced = [];
    const allValues = []
    const columns = [];
    if (data.data.length === 0) return null;
    // const statusKey = { "to_be_invoiced": "To Be invoice", "bbd": "BBD", "in_transit": "In transit", "delivered": "Delivered", "cancelled": "cancelled" };
    // const statusArray = ["delivered", "in_transit", "cancelled", "to_be_invoiced", "bbn"]
    data.data.forEach(ele => {
      
      delivered.push(ele['delivered'] || 0);
      in_transit.push(ele['in_transit']|| 0 );
      invoiced.push(ele['invoiced'] || 0);
      to_be_invoiced.push(ele['to_be_invoiced'] || 0);
      columns.push(ele['region']) ;
    })
    return { delivered, in_transit, invoiced, to_be_invoiced, columns };
  }

  createChart(chartData, Options) {

    const chart = this.utils.deepCopyFunction(HSET.chartData);
    
    const Alldata = [];
    const OneData = [];
    
    // chartData.columns.forEach(data => {
    //   if (data === "All") {
    //     OneData.push(data);
    //   } else {
    //     Alldata.push(data);
    //   }
    // });

    chart.xAxis.categories = OneData.concat(chartData.columns);
    chart.series[0].data = chartData.delivered;
    chart.series[1].data = chartData.in_transit;
    chart.series[2].data = chartData.invoiced;
    chart.series[3].data = chartData.to_be_invoiced;
    
    return chart;
  }
}
